import React from 'react';
import gql from 'graphql-tag';
import useQuery from '../../modules/react/hooks/useQuery';
import Component from '../components/AdvancedSettingsButton';

const GET_DATA = gql`
  query GetAdvancedSettingsData {
    currentCompany {
      id
      ...AdvancedSettingsButtonCurrentCompany
    }
  }

  ${Component.fragments.company}
`;

const propTypes = {};
const defaultProps = {};

const AdvancedSettingsButton = () => {
  const { data, loading } = useQuery(GET_DATA, { variables: { ssr: false } });

  if (loading) {
    return null;
  }

  return <Component company={data.currentCompany} />;
};

AdvancedSettingsButton.propTypes = propTypes;
AdvancedSettingsButton.defaultProps = defaultProps;

export default AdvancedSettingsButton;
